import React from 'react';
import Router from 'next/router';
import { getPriceOptions } from '~/src/api/equipment';
import ProductCard from '~/src/components/Main/Info/ProductCard';
import * as ST from './styled';
import { convertShopPrices } from '~/src/models/price';

const Index = ({ devices, orderText, selectable, createOrder, baseRoute, dataTest }) => {
    const onCreate = async(item, selectedPrice) => {
        await createOrder(item, selectedPrice);
    };

    const getRoute = (item) => {
        return `${baseRoute}/${item.alias ? item.alias : item.id}`.replace('//', '/');
    };

    /**
     * Метод вынесен наружу, потому что он будет открывать модальное окно с превью.
     * На данный момент нужен, чтобы не превращать иконку в ссылку - сделано для SEO
     *
     * @param item
     */
    const onDetail = (item) => {
        Router.push(getRoute(item));
    };

    return (
            <ST.GridContainer data-test={dataTest}>
                {
                    devices.map(item =>
                        <ProductCard
                            key={item.id}
                            orderId={item.id}
                            image={item.image}
                            name={item.title}
                            priceOptions={getPriceOptions(convertShopPrices(item))}
                            route={getRoute(item)}
                            detailHandler={() => onDetail(item)}
                            orderHandler={sel => onCreate(item, sel)}
                            orderText={orderText}
                            selectable={selectable}
                            dataTest='router-button'
                            labels={item.labels}
                            baseRoute={baseRoute}
                        />)
                }
            </ST.GridContainer>
    );
};

export default Index;
